<template>
  <div></div>
<!--  <footer class="footer">-->
<!--    <BContainer fluid>-->
<!--      <BRow>-->
<!--        <BCol sm="6">{{ new Date().getFullYear() - 1 }} - {{ new Date().getFullYear() }} © Simplepharm.</BCol>-->
<!--        <BCol sm="6">-->
<!--          <div class="text-sm-end d-none d-sm-block">Design & Develop by Conquer Innovations Sp. z o.o.</div>-->
<!--        </BCol>-->
<!--      </BRow>-->
<!--    </BContainer>-->
<!--  </footer>-->
</template> 
